import { useContext } from 'react';
import { AppContext } from '../reducers/AppContext';

export const useAppStore = () => useContext(AppContext);